const initialState = {
    quarterPeriodList: [],
    lookup: {},
    currentQuarterIndex: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case "QUARTER_PERIODS_FETCH_SUCCESS":
            return {...state,
                quarterPeriodList: action.payload,
                lookup: action.lookup
            };
        case "SET_SELECTED_QUARTER":
            return {...state, currentQuarterIndex: action.selectedQuarterIndex}
        default:
            return state;
    }
};